import dayjs, { Dayjs } from 'dayjs';

export const STATISTICS_PERIOD_PRESETS = ['all', 'yesterday', 'week', 'month', 'custom'] as const;

export type StatisticsPeriodPreset = (typeof STATISTICS_PERIOD_PRESETS)[number];

export interface StatisticsPeriod {
  preset: StatisticsPeriodPreset;
  start: string | null;
  end: string | null;
}

export interface StatisticsPeriodRange {
  start?: string;
  end?: string;
}

export const DEFAULT_STATISTICS_PERIOD: StatisticsPeriod = {
  preset: 'all',
  start: null,
  end: null,
};

const toRange = (start: Dayjs | null, end: Dayjs | null): StatisticsPeriodRange => ({
  start: start?.startOf('day').toISOString(),
  end: end?.endOf('day').toISOString(),
});

export function resolveStatisticsPeriodRange(
  period: StatisticsPeriod,
  now: Dayjs = dayjs(),
): StatisticsPeriodRange | null {
  switch (period.preset) {
    case 'yesterday': {
      const yesterday = now.subtract(1, 'day');
      return toRange(yesterday, yesterday);
    }
    case 'week':
      return toRange(now.subtract(6, 'day'), now);
    case 'month':
      return toRange(now.subtract(29, 'day'), now);
    case 'custom': {
      if (!period.start || !period.end) return null;
      const start = dayjs(period.start);
      const end = dayjs(period.end);
      if (!start.isValid() || !end.isValid()) return null;
      return toRange(start, end);
    }
    case 'all':
    default:
      return {};
  }
}
